import { AppDispatch, RootState } from '@/app/store';
import { setTranslations, setLoading } from '@/app/store/slices/translationSlice';
import { fetchTranslationsByLocale } from '@/app/services/api/translationService';
import { logger } from '@/app/utils/logger';

/**
 * Fetches all DB translations for the given locale and stores them in Redux.
 * Skips the fetch if translations for this locale are already cached.
 * DB translations are optional -- errors are logged but never surfaced to the user.
 */
export const fetchTranslationsThunk =
    (locale: string) =>
    async (dispatch: AppDispatch, getState: () => RootState) => {
        const state = getState();
        // Skip if already loaded
        if (state.translation.loadedLocales.includes(locale)) return;

        dispatch(setLoading(true));
        try {
            const translations = await fetchTranslationsByLocale(locale);
            dispatch(setTranslations({ locale, translations }));
        } catch (error) {
            // DB translations are optional -- silently fail so the app still works
            logger.warn('Failed to fetch DB translations for locale', { locale, error });
        } finally {
            dispatch(setLoading(false));
        }
    };
